// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__T6W5k","rootSmall":"AddTileButton_rootSmall__2Y1l7"};